import type { Theme } from '@emotion/react';
import { css } from '@emotion/react';

export const container = (theme: Theme) => css`
  position: relative;
  border: 1px solid ${theme.palette.warning.main};
  border-radius: ${theme.borderRadius.sm};
  overflow: hidden;
  margin: ${theme.spacing[24]} 0;
`;

export const content = (theme: Theme) => css`
  display: flex;
  position: relative;
  flex-direction: column;
  width: 100%;
  padding: 0 ${theme.spacing[16]};
`;
